// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  COMMON_TOGGLE_BROADCAST,
} from './constants';

export function toggleBroadcast() {
  return {
    type: COMMON_TOGGLE_BROADCAST,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_TOGGLE_BROADCAST:
      return {
        ...state,
        broadcastModalShow: !state.broadcastModalShow,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/common/redux/toggleBroadcast.js